/**
 * Das erste Glied: der Bereich, in dem die Seite liegt.
 *
 * Holt seine Beschriftung aus `shared/config/navigation.ts` — derselben
 * Liste, aus der die Navigation links ihre Einträge baut. Zwei Listen wären
 * eine zu viel: Wer den Bereich dort umbenennt und hier nicht, bekommt keinen
 * Fehler, sondern zwei Namen für dieselbe Sache.
 *
 * Kennt die Navigation den Pfad nicht, fällt es auf das Pfadsegment zurück
 * statt auf nichts. Eine leere Brotkrume mit einem Trenner davor sieht aus
 * wie ein Fehler; „substitutions" sieht aus wie ein fehlender Eintrag — und
 * das ist es dann auch.
 */

import { navLabelForPath } from '@shared/config';
import type { CrumbComponent } from './route-handle';

export const SectionCrumb: CrumbComponent = ({ match }) => (
  <>{navLabelForPath(match.pathname) ?? match.pathname.replace(/^\//, '')}</>
);
